import React from "react";
import "../../styles/Language.css";
import Header from "../../ReUseAbleComp/Header.jsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Language = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Helmet>
        <title>Language</title>
      </Helmet>
      <div className="bg-image"></div>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />

      <div className="lang_langSelect">
        <Link to="/EngUnits" className="res-circle">
          <div className="circle-txt">ENG</div>
        </Link>
        <Link to="/UrduUnits" className="res-circle">
          <div className="circle-txt">اردو</div>
        </Link>
        <Link to="/PashtoUnits" className="res-circle">
          <div className="circle-txt">پښتو</div>
        </Link>
      </div>
    </>
  );
};

export default Language;
